import React from "react";

export default function StatusPill({ status, map, testid }) {
  const s = map?.[status] || { label: status, cls: "pill-mute" };
  return (
    <span data-testid={testid} className={`pill ${s.cls}`}>{s.label}</span>
  );
}
